import * as getters from './getters'
import * as actions from './actions'
import * as mutations from './mutations'

let state = {
  categories: [],
  customCategories: []
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
